import { render } from "./PageTitleBrandIcon.vue?vue&type=template&id=21aa6847"
import script from "./PageTitleBrandIcon.vue?vue&type=script&lang=js"
export * from "./PageTitleBrandIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PageTitleBrandIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21aa6847"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21aa6847', __exports__)) {
    api.reload('21aa6847', __exports__)
  }
  
  module.hot.accept("./PageTitleBrandIcon.vue?vue&type=template&id=21aa6847", () => {
    api.rerender('21aa6847', render)
  })

}


export default __exports__